@if (message) {
  <section class="message-container" @messageInOut>
    <div class="message" [ngClass]="message.level === MessageLevel.INFO ? 'info' : 'warning'">
      <header>
        <span>{{ message.message }}</span>
        <mat-icon fontIcon="close" (click)="message = undefined"></mat-icon>
      </header>
      @if (message.details) {
        <div>{{ message.details }}</div>
      }
    </div>
  </section>
}

@if (showLogin) {
  <div class="addin-container login-screen">
    <h2 class="heading-underline">Login to begin</h2>
    <app-login-tenant (loginSuccess)="loginSuccess($event)"></app-login-tenant>
  </div>
}

@if (!showLogin) {
  @if (showEntitySelection) {
    <div class="addin-container">
      <app-entity-selection (entitySelectedEvent)="targetEntitySelected($event)"> </app-entity-selection>
    </div>
  } @else {
    <div class="addin-container {{ identity?.namespace }}">
      @if (!entityMeta) {
        <app-field-selection-skeleton></app-field-selection-skeleton>
      }
      @if (entityMeta) {
        <app-field-selection
          [signatureProviderName]="signatureProviderName"
          (fieldInsertedEvent)="fieldInserted($event)"
          (signatureInsertedEvent)="signatureFieldClicked($event)"
          (fieldUpdatedEvent)="fieldUpdated($event)"
          >
        </app-field-selection>
      }
    </div>
  }
}

<app-toolbar style="width: 100%"></app-toolbar>

<app-debugging></app-debugging>

<app-footer [loggedOut]="showLogin" (onLogout)="logout()"></app-footer>

<app-version></app-version>
